import React from "react";
import "./Menu.css";

const menu = {
  breakfast: [
    {
      name: "Ruga’s Big Breakfast",
      desc:
        "Barossa free range eggs, bacon, chorizo, hash brown, grilled mushrooms & cherry tomatoes w/ ciabatta toast",
      price: 22.9
    },
    {
      name: "Eggs Your Way",
      desc:
        "Barossa free range eggs poached, sunny-side-up or scrambled w/ ciabatta toast",
      price: 12.9
    },
    {
      name: "The Australian Omelette",
      desc: "Ham, cheese, tomato & onion",
      price: 16.9
    },
    {
      name: "The Italian Omelette",
      desc: "Salami, sun dried tomatoes, onion & spinach",
      price: 16.9
    },
    {
      name: "The Vego Omelette",
      desc: "Tomato, mushroom, spinach & cheese",
      price: 16.9
    },
    {
      name: "Ruga’s Smashed Avo",
      desc:
        "Ciabatta toast w/ smashed avo, crumbed fetta & balsamic glaze (add poached egg +$3.50)",
      price: 13.9
    },
    {
      name: "Brekky Wrap",
      desc:
        "Bacon, egg, Old English cheese, jalapenos, spinach, avocado, hash brown & peri peri mayo",
      price: 14.9
    },
    {
      name: "Ruga’s BS Roll",
      desc:
        "Bacon, egg, Old English cheese, grilled tomato & peri peri mayo (add wrap +$2.00)",
      price: 9.9
    },
    {
      name: "The Boss Roll",
      desc:
        "Bacon, egg, spinach, fetta, avocado & peri peri mayo (add wrap +$2.00)",
      price: 10.9
    },
    {
      name: "Johnny Princess Roll",
      desc:
        "Bacon, egg, spinach, avocado, red onion, tomato, Old English cheese, hash brown & hollandaise sauce (add wrap +$2.00)",
      price: 13.9
    },
    {
      name: "Bacon & Egg Roll",
      desc: "",
      price: 8.9
    },
    {
      name: "Bacon & Egg Sandwich",
      desc: "",
      price: 7.9
    },
    {
      name: "Ciabatta Toast (2 pieces)",
      desc: "",
      price: 6.9
    },
    {
      name: "Fruit Toast (2 pieces)",
      desc: "",
      price: 7.9
    },
    {
      name: "Muesli & Yoghurt Bowl",
      desc: "",
      price: 11.9
    }
  ],
  breakfastAdds: [
    { name: "Bacon", price: 5.0 },
    { name: "Chorizo", price: 4.0 },
    { name: "Barossa free range egg", price: 3.5 },
    { name: "Cherry tomatoes", price: 3.0 },
    { name: "Grilled mushrooms", price: 3.0 },
    { name: "Hash brown", price: 3.0 },
    { name: "Ciabatta toast", price: 4.0 },
    { name: "Avocado", price: 3.0 }
  ],
  drinks: [
    {
      name: "Milkshakes",
      desc: "Chocolate / banana / strawberry / vanilla / caramel",
      price: 8.0
    },
    {
      name: "Thickshakes",
      desc: "Chocolate / banana / strawberry / vanilla / caramel",
      price: 9.0
    },
    {
      name: "Deluxe Milkshakes",
      desc: "Snickers / banana choc chip",
      price: 8.5
    },
    {
      name: "Deluxe Thickshakes",
      desc: "Snickers / banana choc chip",
      price: 9.5
    },
    {
      name: "Home-made Iced Coffee",
      desc: "Cream add $0.50",
      price: 8.0
    },
    {
      name: "Home-made Iced Chocolate",
      desc: "Cream add $0.50",
      price: 8.0
    }
  ],
  smoothies: [
    {
      name: "Ruga’s Special",
      desc: "Banana, berries, oats, yoghurt & milk",
      price: 10.5
    },
    {
      name: "Banana & Mango",
      desc: "Banana, mango, mango nectar & yoghurt",
      price: 10.5
    },
    {
      name: "Apple Berry",
      desc: "Mixed berries, apple juice & yoghurt",
      price: 10.5
    }
  ],
  juices: [
    {
      name: "Pink Lady",
      desc: "Apples, watermelon, strawberries & mixed berries",
      price: 9.5
    },
    {
      name: "Gone Troppo",
      desc: "Banana, pineapple, orange, mango",
      price: 9.5
    },
    {
      name: "Kick Start",
      desc: "Apple, orange, kiwi fruit & carrot",
      price: 9.5
    }
  ],
  sandwichBar: [
    {
      name: "B.L.T.",
      desc: "Bacon, lettuce, tomato & mayo",
      price: 6.5
    },
    {
      name: "Meatlovers",
      desc: "Chicken, bacon, salami, cheese, onion & BBQ sauce",
      price: 7.9
    },
    {
      name: "Mediterranean",
      desc: "Salami, roasted capsicum, fetta & olives",
      price: 7.5
    },
    {
      name: "Chicken Combo",
      desc: "Chicken or chicken tenders, bacon, cheese, tomato, lettuce & mayo",
      price: 7.9
    },
    {
      name: "Cajun Chicken",
      desc: "Chicken, avocado, roasted capsicum, spinach & peri peri",
      price: 7.9
    },
    {
      name: "Sweet Chilli Chicken",
      desc: "Chicken, cheese, avocado, tomato, lettuce & mayo",
      price: 7.5
    },
    {
      name: "Vego",
      desc: "Cheese, avocado, spinach & roast vegetables",
      price: 6.9
    }
  ],
  myoProteins: [
    { name: "Bacon", price: 7.0 },
    { name: "Cheese", price: 6.0 },
    { name: "Curried egg", price: 7.0 },
    { name: "Egg", price: 6.5 },
    { name: "Roast beef", price: 7.0 },
    { name: "Roast chicken", price: 7.0 },
    { name: "Salami", price: 7.0 },
    { name: "Tuna", price: 6.5 },
    { name: "Turkey", price: 7.0 }
  ],
  myoExtras: [
    { name: "Avocado", price: 1.0 },
    { name: "Bacon", price: 3.0 },
    { name: "Beetroot", price: 0.5 },
    { name: "Capsicum", price: 0.5 },
    { name: "Carrot", price: 0.5 },
    { name: "Cheese", price: 0.5 },
    { name: "Old English cheese", price: 0.8 },
    { name: "Cucumber", price: 0.5 },
    { name: "Egg", price: 2.0 },
    { name: "Fetta", price: 0.8 },
    { name: "Gherkin", price: 0.5 },
    { name: "Jalapenos", price: 0.5 },
    { name: "Lettuce", price: 0.5 },
    { name: "Meats", price: 2.0 },
    { name: "Olives", price: 0.8 },
    { name: "Onion", price: 0.5 },
    { name: "Pickled onion", price: 0.5 },
    { name: "Roast capsicum", price: 0.8 },
    { name: "Roast eggplant", price: 0.8 },
    { name: "Roast mushroom", price: 0.8 },
    { name: "Roast pumpkin", price: 0.8 },
    { name: "Spinach", price: 0.8 },
    { name: "Sun dried tomato", price: 0.8 },
    { name: "Tomato", price: 0.5 }
  ],
  spreads: [
    { name: "Cranberry", price: 0.5 },
    { name: "Mustard pickles", price: 0.5 },
    { name: "Aioli", price: 0.2 },
    { name: "BBQ", price: 0.2 },
    { name: "Mayo", price: 0.2 },
    { name: "Mustard", price: 0.2 },
    { name: "Peri peri", price: 0.2 },
    { name: "Ranch", price: 0.2 },
    { name: "Caesar", price: 0.2 },
    { name: "Sriracha", price: 0.2 },
    { name: "Sweet chilli", price: 0.2 },
    { name: "Tomato", price: 0.2 },
    { name: "HP", price: 0.2 }
  ]
};

function List({ items }) {
  return (
    <ul className="menu-table">
      {items.map((i) => (
        <li className="menu-row" key={i.name}>
          <div className="menu-row__main">
            <span className="menu-row__name">{i.name}</span>
            {i.desc ? <span className="menu-row__desc">{i.desc}</span> : null}
          </div>
          <div className="menu-row__price">
            {typeof i.price === "number" ? `$${i.price.toFixed(2)}` : i.price}
          </div>
        </li>
      ))}
    </ul>
  );
}

export default function Menu() {
  return (
    <main className="menu">
      <header className="menu-hero">
        <h1>Our Menu</h1>
        <p>Bright coffee. Fresh bakes. Sunny vibes.</p>
      </header>

      <div className="menu-layout">
        {/* Large box 1: Breakfast */}
        <section className="menu-section menu-section--wide">
          <div className="menu-section__head">
            <h2 className="menu-section__title">Breakfast</h2>
          </div>
          <List items={menu.breakfast} />
          <div className="menu-section__head menu-section__head--sub">
            <h3 className="menu-section__subtitle">Add</h3>
          </div>
          <List items={menu.breakfastAdds} />
        </section>

        {/* Large box 2: Sandwich Bar + Make Your Own */}
        <section className="menu-section menu-section--wide">
          <div className="menu-section__head">
            <h2 className="menu-section__title">Sandwich Bar &amp; Make Your Own</h2>
            <p className="menu-section__note">
              Choice of white or wholemeal bread. Wrap, focaccia or white roll
              add $2.00. Toasting add $0.50.
            </p>
          </div>

          <div className="menu-section__block">
            <h3 className="menu-section__subtitle">Sandwich Bar</h3>
            <List items={menu.sandwichBar} />
          </div>

          <div className="menu-section__block">
            <h3 className="menu-section__subtitle">Make Your Own - Choose your protein/base</h3>
            <List items={menu.myoProteins} />
          </div>

          <div className="menu-section__block">
            <h3 className="menu-section__subtitle">Choose your extras</h3>
            <List items={menu.myoExtras} />
          </div>

          <div className="menu-section__block">
            <h3 className="menu-section__subtitle">
              Choice of spreads/dressings
            </h3>
            <List items={menu.spreads} />
          </div>
        </section>

        {/* Last row: 3 smaller drink boxes */}
        <div className="menu-layout__grid">
          <section className="menu-section">
            <div className="menu-section__head">
              <h2 className="menu-section__title">Drinks</h2>
            </div>
            <List items={menu.drinks} />
          </section>

          <section className="menu-section">
            <div className="menu-section__head">
              <h2 className="menu-section__title">Smoothies</h2>
            </div>
            <List items={menu.smoothies} />
          </section>

          <section className="menu-section">
            <div className="menu-section__head">
              <h2 className="menu-section__title">Fresh Juices</h2>
            </div>
            <List items={menu.juices} />
          </section>
        </div>
      </div>

      <span className="menu-foot">
        Ruga&apos;s Cafe. No substitutes. Public holiday surcharge applies.
      </span>
    </main>
  );
}
